import { createContext, useContext } from "react";

type FormContentType = {
  id?: string;
};

export const FormControlContext = createContext<FormContentType>({});

export const useFormControlContext = () => useContext(FormControlContext);
